import { Headline3, Body1 } from 'stories/elements/Typography/Text'
import { Know, KnowTranscript } from 'interfaces/Know'
import theme from 'stories/utils/theme'
import { returnTranscriptText } from 'lib/features/Know/know'
import _useTranslation from 'lib/hooks/_useTranslation'
import styled, { css } from 'styled-components'

const TranscriptWrapper = styled.div<{ isDarkTheme?: boolean }>`
    overflow-wrap: anywhere;
    padding: 25px 5%;
    @media (max-width: 750px) {
        padding: 15px;
    }
    * {
        overflow-wrap: anywhere;
        word-break: break-all;
        white-space: pre-line;
        ${({ isDarkTheme }) =>
            isDarkTheme
                ? css`
                      color: ${theme.colors.white};
                  `
                : ''}
    }
`

interface Props {
    transcript: KnowTranscript | null
    know: Know
}

const KnowSEOTranscriptEnding = ({ transcript: knowTranscript }: Props) => {
    const { transcript } = knowTranscript || {}
    const { t } = _useTranslation('knows')
    const isDarkTheme = true

    if (!transcript) return null

    return returnTranscriptText(transcript, false) ? (
        <TranscriptWrapper isDarkTheme={isDarkTheme}>
            <Headline3 fontSize={16} color={theme.colors.subtitleBlack} marginBottom={5}>
                {t('knows/knowDetailsTranscriptHeading')}
            </Headline3>
            <Body1 fontFamily="var(--font-inter)" fontWeight={400} fontSize={14} color={theme.colors.body2Black}>
                {returnTranscriptText(transcript, false)}
            </Body1>
        </TranscriptWrapper>
    ) : null
}

export default KnowSEOTranscriptEnding
